import { formatAddress, formatAddressLine } from '~~/common/utils/addressFormatter';

export default {
  methods: {
    formatAddress (address) {
      return formatAddress(address);
    },
    formatAddressLine (address) {
      return formatAddressLine(address, this.$awt);
    },
  },
};
